(function() {
	'use strict';

	angular.module('inventoryApp').controller('InventoryController',
			InventoryController);

	InventoryController.$inject = [ '$scope', '$state', '$stateParams',
			'$base64','CONST_EXPORTS', '$window', 'InventoryService', 'CommonService',
			'$http', '$log', 'Upload', 'AlertService','EVENT',
			'authExpiredInterceptor', '$uibModal', 'NgTableParams' ];

	function InventoryController($scope, $state, $stateParams, $base64,CONST_EXPORTS,
			$window, InventoryService, CommonService, $http, $log, Upload,
			AlertService,EVENT, authExpiredInterceptor, $uibModal, NgTableParams) {
		var inventoryCtr = this;
		var param = $stateParams;
		inventoryCtr.stockLst=[];
		inventoryCtr.CONST_EXPORTS=CONST_EXPORTS;
		inventoryCtr.lengthSearch=0;
		$scope.loading = false;
		$scope.$on(EVENT.changeOffice, function(event, args) {
			if(event.name = 'CHANGE_OFFICE') {
				$state.go($state.current, {}, {reload: true});
			}
		});
		inventoryCtr.dateOptions = {
			maxDate : new Date()
		};
		inventoryCtr.find = function() {
				InventoryService.postList({
					uri : 'getInventoryLst'
				}, inventoryCtr, function(result) {
					if (result) {
						inventoryCtr.lengthSearch = result.length;
						inventoryCtr.tableParams = new NgTableParams({
							page : 1, // show first page
							count : 5
						// count per page
						}, {
							filterDelay : 0,
							dataset : result
						});
					}
				}, function(error) {
				});
		}
		InventoryService.get({uri : 'getStockByOffice'}).$promise.then(function(result){
//						inventoryCtr.stockLst.push(result);
						inventoryCtr.stockLst = result.listStockDTO;
						inventoryCtr.stockId=inventoryCtr.stockLst[0].stockId;
							CommonService.query({masterurl:'product-group-active'}).$promise.then(function(result) {
								inventoryCtr.productGroupLst = result;
								InventoryService.postList({
									uri : 'getInventoryLst'
								}, inventoryCtr, function(result) {
									if (result) {
										inventoryCtr.lengthSearch = result.length;
										inventoryCtr.tableParams = new NgTableParams({
											page : 1, // show first page
											count : 5
										// count per page
										}, {
											filterDelay : 0,
											dataset : result
										});
									}
								}, function(error) {
								});
							});
		});
//		inventoryCtr.inventoryReport = function() {
//			InventoryService.download({uri:'inventory-report'},inventoryCtr);
//        }
		inventoryCtr.changeProductGroup=function(){
			CommonService.query({masterurl:'find-product-active-by-group',productGroupId: inventoryCtr.productGroupId}).$promise.then(function(result){
        		inventoryCtr.productLst = result;
        	});
		}
		inventoryCtr.viewSeries=function(productId,stockId){
			InventoryService.query({
				uri : 'getLstSeries'
			, productId:productId,stockId:stockId}, function(result) {
				inventoryCtr.items = result;
				$scope.animationsEnabled = true;
				var modalInstance = $uibModal.open({
			      animation: $scope.animationsEnabled,
			      templateUrl: GLOBAL_URL
					+ 'partial?uri=e-stock/inventory/template/inventory-dialog',
			      controller: 'InventoryDialogController as inventoryCtrDial',
			      size: 'lg',
			      resolve: {
			        items: function () {
			          return inventoryCtr.items;
			        }
			      }
			    });
			});
		}
		inventoryCtr.inventoryReport = function() {
				$scope.loading=true;
				InventoryService.download({uri:'inventory-report'}, inventoryCtr,function(result) {
		        		$scope.loading=false;
		        }, function(error){
						$scope.loading=false;
		    	});	
        }
		inventoryCtr.dod = new Date();
		inventoryCtr.openDod = function() {
			inventoryCtr.popupDod.opened = true;
		};

		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy',
				'shortDate' ];
		$scope.format = $scope.formats[2];
		$scope.altInputFormats = [ 'M!/d!/yyyy' ];
		inventoryCtr.popupDod = {
			opened : false
		};

	}

})();
